import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AuthService } from '../../services/auth.service';
import { IncidenciasService } from '../../services/incidencias.service';
import { LocalizationService } from '../../services/localization.service';

import { MatDialog, MatDialogConfig } from '@angular/material';
import { ErrorHelper } from '../../models/ErrorHelper';
import { IncidenciaModel } from '../../models/IncidenciaModel';
import { ModelHelpers } from '../../models/ModelHelpers';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { IncidenciaCloseComponent } from './incidencia-close/incidencia-close.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-incidencias-edit',
  templateUrl: './incidencias-edit.component.html',
  styleUrls: ['./incidencias-edit.component.scss']
})
export class IncidenciasEditComponent implements OnInit {

  incidenciaForm: FormGroup;
  incidenciaModel: any;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  errorMessage: any = '';

  activoCierre = true;

  localization: LocalizationService;
  options: any = {
    format: 'DD/MM/YYYY'
  };

  tasacionInfo: any = {
    id: '',
    cliente: '',
    entidad: '',
    ciudad: ''
  };

  tipoIncidenciaList: any[] = [
    { id: 1, displayName: "No entrega documentación" },
    { id: 2, displayName: "No contacto con cliente" },
    { id: 99, displayName: "Otros" }];

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, localization: LocalizationService,
    private _IncidenciasService: IncidenciasService, private _authService: AuthService, private _location: Location,
    private _router: Router, public dateHelper: DateHelper, public matDialog: MatDialog) {

    this.localization = localization;

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    } else {
      this.id = 0;
    }

    this.initForm();

  }

  ngOnInit() {


  }

  initForm() {    
    this.incidenciaForm = this._fb.group({
      id: 0,
      actuacionRealizada: ['', Validators.required],
      detalle: ['', Validators.required],
      cierre: [{ value: '', disabled: !(this._authService.authDataCache.admin || this._authService.authDataCache.gestor) }],
      tasacionId: [{ value: '', disabled: true }, Validators.required],
      fechaInicio: [this.dateHelper.dateFormat_iso(new Date())],
      fechaCierre: [{ value: '', disabled: true }],
      tipoMotivo: 0
    });

    if (this._avRoute.snapshot.params['tasacion']) {
      this.incidenciaForm.get('tasacionId').setValue(this._avRoute.snapshot.params['tasacion']);
    }

    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      this._IncidenciasService.getIncidencia(this.id)
        .subscribe((resp: any) => {
          this.incidenciaModel = resp;
          // this.incidenciaModel.fechaInicio = this.moment(this.incidenciaModel.fechaInicio)
          if (resp.estado === 'Error') {
            this._router.navigate(['/incidencias']);
          }
          this.incidenciaForm.patchValue(resp);
          console.log(this.incidenciaForm.value)
          console.log(this.incidenciaModel)
          if (this.incidenciaModel.fechaCierre === null) {
            this.activoCierre = true;
          } else {
            this.activoCierre = false;
          }

          this._IncidenciasService.getTasacionID(this.incidenciaForm.get('tasacionId').value).subscribe(data => this.tasacionInfo = data);
        }, error => { this.errorMessage = error; this.back(); });
    } else {
      this.isNewElement = true;
      this._IncidenciasService.getTasacionID(this.incidenciaForm.get('tasacionId').value).subscribe(data => this.tasacionInfo = data);
      this.activoCierre = true;
    }

  }

  back() {
    this._router.navigate(['/incidencias']);
  }

  save() {

    if (!this.incidenciaForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._IncidenciasService.createIncidencia(this.incidenciaForm.getRawValue())
        .subscribe((data: any) => {
          if (data.estado == 'Error') {
            this.errorMessage = data.mensaje;
          }
          this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
        }, error => {
          this.errorMessage = ErrorHelper.GetClientError(error);
        }
        );
    } else {
      this._IncidenciasService.updateIncidencia(this.id, this.incidenciaForm.getRawValue())
        .subscribe((data: any) => {
          if (data.estado === 'Correcto') {
            this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
            // this._router.navigate(['/incidencias']);
          } else {
            this.errorMessage = data.mensaje;
          }
        }, error => {
          this.errorMessage = ErrorHelper.GetClientError(error);
        });
    }
  }

  public moment(data) {
    if (data == null || data === '') {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY');
  }

  public volverIncidencias() {
    this._router.navigate(['/incidencias-abiertas']);
  }

  public volverTasacion(tasacion: number) {
    this._router.navigate(['/tasacion/edit/' + tasacion]);
  }

  get actuacionRealizada() { return this.incidenciaForm.get('actuacionRealizada'); }
  get detalle() { return this.incidenciaForm.get('detalle'); }


  closeIncidencia() {
    const dialogConfig = new MatDialogConfig();
    let incidenciaModel = new IncidenciaModel();
    ModelHelpers.copyFromForm(this.incidenciaForm.value, incidenciaModel);
    dialogConfig.width = "700px"
    dialogConfig.data = {
      id: this.tasacionInfo.id,
      model: incidenciaModel
    }
    let dlgRef = this.matDialog.open(IncidenciaCloseComponent, dialogConfig);
    dlgRef.afterClosed().subscribe(result => {
      if (result) {
        this._router.navigate(['/tasacion/edit/' + this.tasacionInfo.id]);
      }
    })
  }
}
